<template>
  <Toolbar classes="pt-3" />

  <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
              </svg>
            </span>
            <input type="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar..." @keyup.enter="fetchBudgets">
          </div>
        </div>
        <div class="card-toolbar">
          <button class="btn btn-primary" type="button" @click="createBudget">
            <i class="bi bi-plus-lg me-1"></i>Novo orçamento
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-hover table-row-bordered">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Paciente</th>
              <th>Tipo</th>
              <th>Forma de pagamento</th>
              <th>Valor</th>
              <th>Validade</th>
              <th>Data</th>
              <th>Status</th>
              <th>Finalizado por</th>
              <th class="text-center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="budget in budgets.data" :key="budget.id_budget">
              <td class="d-flex align-items-center">
                <div class="d-flex flex-column">
                  <span class="text-gray-800 text-hover-primary mb-1">{{ budget.patient.patient_name }}</span>
                  <span>{{ budget.patient.patient_cpf }}</span>
                </div>
              </td>
              <td>{{ budget.budget_type_dsc }}</td>
              <td>{{ budget.payment_method.paymeth_name }}</td>
              <td>
                R$ {{ Number(budget.budget_value).toFixed(2) }}
                <span class="text-muted fs-8 d-block" v-if="Number(budget.budget_discount || 0) > 0">
                  desconto de R$ {{ Number(budget.budget_discount).toFixed(2) }}
                </span>
              </td>
              <td>
                <template v-if="budget.budget_valid_until">
                  {{ formatDate(budget.budget_valid_until) }}
                  <span class="badge badge-light-danger d-block mt-1" v-if="budget.budget_expired">Vencido</span>
                </template>
                <span class="text-muted" v-else>sem prazo</span>
              </td>
              <td>{{ formatDate(budget.created_at) }}</td>
              <td>
                <span class="badge" :class="statusClass(budget.budget_status)">
                  {{ budget.budget_status_dsc }}
                </span>
              </td>
              <td>{{ budget.finished_by?.user_name }}</td>
              <td class="text-center" style="min-width: 125px;">
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="editBudget(budget)"
                        title="Editar orçamento">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="finishBudget(budget)" v-if="budget.budget_status === 'paid'"
                        title="Aprovar orçamento">
                  <i class="bi bi-check-all"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="cancelBudget(budget)"
                        v-if="!['cancelled', 'finished'].includes(budget.budget_status)"
                        title="Cancelar orçamento">
                  <i class="bi bi-x-circle"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="printBudget(budget)"
                        title="Imprimir orçamento">
                  <i class="bi bi-printer"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="emailBudget(budget)"
                        title="Enviar por e-mail">
                  <i class="bi bi-envelope"></i>
                </button>
                <button v-if="budget.budget_by === 'place'"
                    class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="deleteBudget(budget)"
                        title="Apagar orçamento">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <Pagination :data="budgets"/>
        </div>
      </div>
    </div>

    <BudgetModal :budget="selectedBudget" @saved="fetchBudgets" @onClose="selectedBudget = null" />
  </div>
</template>

<script>
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import BudgetModal from "@/views/budget/BudgetModal.vue";
import Pagination from "@/components/Pagination.vue";
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import Loader from "@/helpers/loader";

export default {
  name: "BudgetList",
  components: {Pagination, BudgetModal, Toolbar},
  data() {
    return {
      search: '',
      selectedBudget: null,
      budgets: [],
    }
  },
  mounted() {
    this.resetPage();
    this.fetchBudgets();
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('pt-BR');
    },
    statusClass(status) {
      return {
        pending: 'badge-light-warning',
        paid: 'badge-light-primary',
        finished: 'badge-light-success',
        cancelled: 'badge-light-danger',
        waiting_payment: 'badge-light-info',
        payment_failed: 'badge-light-danger',
      }[status] ?? 'badge-light';
    },
    /** Abre o PDF numa aba nova: dá para imprimir na hora ou salvar. */
    async printBudget(budget) {
      Loader.show('Gerando orçamento', 'Aguarde...');
      try {
        const response = await http.get(
            `/places/${this.place.id_place}/budgets/${budget.id_budget}/pdf`,
            {responseType: 'blob'}
        );
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
        const tab = window.open(url, '_blank');
        if (!tab) {
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `orcamento-${budget.id_budget}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (e) {
        Alert.toastError('Não foi possível gerar o PDF do orçamento.');
      } finally {
        Loader.close();
      }
    },
    async emailBudget(budget) {
      const result = await Swal.fire({
        title: 'Enviar orçamento por e-mail',
        input: 'email',
        inputValue: budget.patient?.patient_email ?? '',
        inputPlaceholder: 'email@paciente.com',
        showCancelButton: true,
        confirmButtonColor: '#780f5a',
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        inputValidator: value => (!value ? 'Informe o e-mail do paciente.' : undefined),
      });

      if (!result.isConfirmed) return;

      Loader.show('Enviando orçamento', 'Aguarde...');
      try {
        const response = await http.post(
            `/places/${this.place.id_place}/budgets/${budget.id_budget}/email`,
            {email: result.value}
        );
        Alert.toastSuccess(response.data?.message ?? 'Orçamento enviado!');
      } catch (e) {
        Alert.toastError(e.response?.data ?? 'Não foi possível enviar o orçamento.');
      } finally {
        Loader.close();
      }
    },
    fetchBudgets() {
      this.budgets = [];
      http.get(`/places/${this.place.id_place}/budgets`, {
        params: {
          'page': this.$route.query.page,
          'search': this.search,
          'per_page': 10,
        }
      }).then((response) => {
        this.budgets = response.data;
      });
    },
    async finishBudget(budget) {
      if (budget.payment_method.is_pix || budget.payment_method.is_credit_card) {
        Swal.fire({
          title: 'Palavra-chave',
          input: 'textarea',
          icon: 'question',
          inputLabel: 'O paciente recebeu via WhatsApp.',
          allowEscapeKey: true,
          showCloseButton: true,
          allowOutsideClick: false,
          confirmButtonColor: 'rgba(120,15,90,0.8)',
          confirmButtonText: "APROVAR E RECEBER HOJE",
          showDenyButton: true,
          inputPlaceholder: 'Ex. VIRTUDE.',
          denyButtonText: `APROVAR SEM PALAVRA-CHAVE`,
          denyButtonColor: "rgb(83,136,235)",
          footer: '<small><i>Receba o seu pagamento ainda hoje informando a palavra-chave.</i></small>',
          inputValidator: (value) => {
            if (!value) {
              return 'Informe a palavra-chave.'
            }
          }
        }).then(async (result) => {
          if (result.isDismissed) {
            return;
          }

          const keyword = result.value;
          let parameters = {keyword: keyword}
          await callApi(parameters, this.place);
          this.fetchBudgets();
        });

        return;
      }

      function callApi(parameters, place) {
        return http.patch(`/places/${place.id_place}/budgets/${budget.id_budget}/finish`, parameters)
          .then(() => {
            Alert.toastSuccess('Operação realizada com sucesso!');
          })
          .catch((e) => {
            Alert.error(e.response.data);
          });
      }

      await callApi({}, this.place);
      this.fetchBudgets();
    },
    editBudget(budget) {
      this.selectedBudget = budget;

      Modal.toggle('#budgetModal');
    },
    createBudget() {
      this.selectedBudget = null;
      Modal.toggle('#budgetModal');
    },
    cancelBudget(budget) {
      Swal.fire({
        title: 'Cancelar orçamento',
        text: "Tem certeza que deseja cancelar este orçamento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar',
        cancelButtonText: 'Voltar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (!result.isConfirmed) return;
        http.patch(`/places/${this.place.id_place}/budgets/${budget.id_budget}/cancel`).then(() => {
          Alert.toastSuccess('Orçamento cancelado com sucesso!');
          this.fetchBudgets();
        }).catch((e) => {
          Alert.error(e.response?.data?.message ?? e.response?.data);
        });
      });
    },
    deleteBudget(budget) {
      Swal.fire({
        title: 'Atenção',
        text: "Tem certeza que deseja remover?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/budgets/${budget.id_budget}`).then(() => {
            this.fetchBudgets();
          }).catch((e) => {
            Alert.error(e.response.data);
          });
        }
      });
    },
    resetPage() {
      const query = {...this.$route.query, page: 1};
      this.$router.push({path: this.$route.path, query});
    }
  }
}
</script>
